export const checkForDuplicatePhoneError = (e: { data: any }) => {
  const baseError = e?.data?.resource_errors?.base;

  return baseError && baseError?.[0]?.includes('phone number');
};
